function QuizSavingOverlay({
  message = "جاري حفظ إجابتك...",
  fullScreen = false,
}) {
  return (
    <div
      className={`quiz-saving-overlay${
        fullScreen ? " quiz-saving-overlay--fullscreen" : ""
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="quiz-saving-overlay__box">
        <span className="quiz-saving-loader" aria-hidden="true" />
        <p>{message}</p>
      </div>
    </div>
  );
}

export default QuizSavingOverlay;
